function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M96,309.333c-5.891,0-10.667-4.776-10.667-10.667V192c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667v106.667C106.667,304.558,101.891,309.333,96,309.333z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M224,309.333c-5.891,0-10.667-4.776-10.667-10.667v-96h-1.92L191.787,300.8c-1.172,5.773-6.803,9.503-12.576,8.331 c-4.198-0.852-7.478-4.133-8.331-8.331l-19.627-98.133h-1.92v96c0,5.891-4.776,10.667-10.667,10.667S128,304.558,128,298.667V192 c0-5.891,4.776-10.667,10.667-10.667H160c5.07-0.001,9.439,3.566,10.453,8.533l10.88,54.421l10.88-54.421 c1.014-4.967,5.384-8.534,10.453-8.533H224c5.891,0,10.667,4.776,10.667,10.667v106.667 C234.667,304.558,229.891,309.333,224,309.333z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M288,309.333h-21.333c-5.891,0-10.667-4.776-10.667-10.667V192c0-5.891,4.776-10.667,10.667-10.667H288 c17.673,0,32,14.327,32,32v64C320,295.006,305.673,309.333,288,309.333z M277.333,288H288c5.891,0,10.667-4.776,10.667-10.667v-64 c0-5.891-4.776-10.667-10.667-10.667h-10.667V288z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M352,309.333c-5.891,0-10.667-4.776-10.667-10.667V192c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667v106.667C362.667,304.558,357.891,309.333,352,309.333z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M373.333,309.333c-17.673,0-32-14.327-32-32v-42.667c0-17.673,14.327-32,32-32s32,14.327,32,32v42.667 C405.333,295.006,391.006,309.333,373.333,309.333z M373.333,224c-5.891,0-10.667,4.776-10.667,10.667v42.667 c0,5.891,4.776,10.667,10.667,10.667S384,283.224,384,277.333v-42.667C384,228.776,379.224,224,373.333,224z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M437.333,352h-384C23.878,352,0,328.122,0,298.667V192c0-29.455,23.878-53.333,53.333-53.333h384 c29.455,0,53.333,23.878,53.333,53.333v106.667C490.667,328.122,466.789,352,437.333,352z M53.333,160c-17.673,0-32,14.327-32,32 v106.667c0,17.673,14.327,32,32,32l0,0h384c17.673,0,32-14.327,32-32l0,0V192c0-17.673-14.327-32-32-32H53.333z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

function SvgImdb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 122.6667 490.667 245.3335",
    style: {
      enableBackground: "new 0 0 490.667 245.667"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M53.333,138.667h384c29.455,0,53.333,23.878,53.333,53.333v106.667 c0,29.455-23.878,53.333-53.333,53.333h-384C23.878,352,0,328.122,0,298.667V192C0,162.545,23.878,138.667,53.333,138.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M96,309.333c-5.891,0-10.667-4.776-10.667-10.667V192c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667v106.667C106.667,304.558,101.891,309.333,96,309.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M224,309.333c-5.891,0-10.667-4.776-10.667-10.667v-96h-1.92L191.787,300.8 c-1.172,5.773-6.803,9.503-12.576,8.331c-4.198-0.852-7.478-4.133-8.331-8.331l-19.627-98.133h-1.92v96 c0,5.891-4.776,10.667-10.667,10.667S128,304.558,128,298.667V192c0-5.891,4.776-10.667,10.667-10.667H160 c5.07-0.001,9.439,3.566,10.453,8.533l10.88,54.4l10.88-54.4c1.014-4.967,5.384-8.534,10.453-8.533H224 c5.891,0,10.667,4.776,10.667,10.667v106.667C234.667,304.558,229.891,309.333,224,309.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M288,309.333h-21.333c-5.891,0-10.667-4.776-10.667-10.667V192c0-5.891,4.776-10.667,10.667-10.667 H288c17.673,0,32,14.327,32,32v64C320,295.006,305.673,309.333,288,309.333z M277.333,288H288c5.891,0,10.667-4.776,10.667-10.667 v-64c0-5.891-4.776-10.667-10.667-10.667h-10.667V288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M352,309.333c-5.891,0-10.667-4.776-10.667-10.667V192c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667v106.667C362.667,304.558,357.891,309.333,352,309.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M373.333,309.333c-17.673,0-32-14.327-32-32v-42.667c0-17.673,14.327-32,32-32s32,14.327,32,32 v42.667C405.333,295.006,391.006,309.333,373.333,309.333z M373.333,224c-5.891,0-10.667,4.776-10.667,10.667v42.667 c0,5.891,4.776,10.667,10.667,10.667S384,283.224,384,277.333v-42.667C384,228.776,379.224,224,373.333,224z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImdb);
export default __webpack_public_path__ + "static/media/imdb.6f52990e.svg";
export { ForwardRef as ReactComponent };